export default __webpack_public_path__ + "static/media/Rectangle 25.bb8d2073.jpg";